import { render, staticRenderFns } from "./add-change-user-uac.vue?vue&type=template&id=d906feaa&scoped=true"
import script from "./add-change-user-uac.vue?vue&type=script&lang=js"
export * from "./add-change-user-uac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d906feaa",
  null
  
)

export default component.exports